<template>

    <button v-if="memberEmail" class="relative inline-flex items-center px-3 py-2 text-sm font-semibold rounded-md shadow-xs "
        type="button" @click="openConfirmation" alt="Contact Me" title="">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"
            class="w-5 h-5 shrink-0 fill-electric-50 group-hover:fill-electric-500">
            <path class="fa-secondary" opacity=".4"
                d="M0 64C0 28.7 28.7 0 64 0H448c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H309.3L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V416H64c-35.3 0-64-28.7-64-64V64zM192 176a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm128 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM150.5 238.1c-9.9 8.8-10.7 24-1.9 33.9c26.3 29.4 64.7 48 107.3 48s81-18.6 107.3-48c8.8-9.9 8-25-1.9-33.9s-25-8-33.9 1.9c-17.6 19.7-43.1 32-71.6 32s-53.9-12.3-71.6-32c-8.8-9.9-24-10.7-33.9-1.9z" />
            <path class="fa-primary"
                d="M224 144a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm128 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM184.4 240c-8.8-9.9-24-10.7-33.9-1.9s-10.7 24-1.9 33.9c26.3 29.4 64.7 48 107.3 48s81-18.6 107.3-48c8.8-9.9 8-25-1.9-33.9s-25-8-33.9 1.9c-17.6 19.7-43.1 32-71.6 32s-53.9-12.3-71.6-32z" />
        </svg>
        <span class="ml-4">Contact Me</span>
    </button>
    <a v-else class="relative inline-flex items-center px-3 py-2 text-sm font-semibold rounded-md shadow-xs " href="/login" alt="Contact Me" title="">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"
            class="w-5 h-5 shrink-0 fill-electric-50 group-hover:fill-electric-500">
            <path class="fa-secondary" opacity=".4"
                d="M0 64C0 28.7 28.7 0 64 0H448c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H309.3L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V416H64c-35.3 0-64-28.7-64-64V64zM192 176a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm128 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM150.5 238.1c-9.9 8.8-10.7 24-1.9 33.9c26.3 29.4 64.7 48 107.3 48s81-18.6 107.3-48c8.8-9.9 8-25-1.9-33.9s-25-8-33.9 1.9c-17.6 19.7-43.1 32-71.6 32s-53.9-12.3-71.6-32c-8.8-9.9-24-10.7-33.9-1.9z" />
            <path class="fa-primary"
                d="M224 144a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm128 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM184.4 240c-8.8-9.9-24-10.7-33.9-1.9s-10.7 24-1.9 33.9c26.3 29.4 64.7 48 107.3 48s81-18.6 107.3-48c8.8-9.9 8-25-1.9-33.9s-25-8-33.9 1.9c-17.6 19.7-43.1 32-71.6 32s-53.9-12.3-71.6-32z" />
        </svg>
        <span class="ml-4">Contact Me</span>
    </a>
    <TransitionRoot :show="isOpen" as="template">
        <Dialog as="div" class="relative z-40" @close="closeConfirmation">
            <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100"
                leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
                <div class="fixed inset-0 transition-opacity bg-gray-500 bg-opacity-75" />
            </TransitionChild>

            <div class="fixed inset-0 z-10 overflow-y-auto">
                <div class="flex items-center justify-center min-h-full p-4 text-center sm:p-0">
                    <TransitionChild as="template" enter="ease-out duration-300"
                        enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200"
                        leave-from="opacity-100 translate-y-0 sm:scale-100"
                        leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
                        <DialogPanel
                            class="relative px-4 pt-5 pb-4 overflow-hidden text-left transition-all transform bg-white rounded-lg shadow-xl sm:my-8 sm:max-w-lg sm:w-full sm:p-6">
                            <div class="absolute top-0 right-0 z-40 block pt-4 pr-4">
                                <button
                                    class="text-gray-400 bg-white rounded-md hover:text-gray-600 focus:outline-hidden"
                                    type="button" @click="isOpen = false">
                                    <span class="sr-only">Close</span>
                                    <svg class="w-6 h-6" fill="none" stroke="currentColor" stroke-width="1.5"
                                        viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M6 18L18 6M6 6l12 12" stroke-linecap="round"
                                            stroke-linejoin="round" />
                                    </svg>

                                </button>
                            </div>
                            <div>
                                <div
                                    class="flex items-center justify-center w-12 h-12 mx-auto bg-green-100 rounded-full">
                                    <ChatBubbleBottomCenterIcon aria-hidden="true" class="w-6 h-6 text-green-600" />
                                </div>
                                <div v-if="memberIsPro" class="mt-3 text-center sm:mt-5">
                                    <div v-if="isMessagingEnabled" class="mt-3 text-center sm:mt-5">
                                        <DialogTitle as="h3" class="mb-6 text-lg font-medium leading-6 text-gray-900">
                                            Ask
                                            {{ talentDisplayName }} to get in touch with you!
                                        </DialogTitle>
                                        <div v-if="!isMessageSent" class="mt-2 text-left">
                                            <p class="text-sm text-clay-800">
                                                <strong>We'll send {{ talentDisplayName }} the following
                                                    message:</strong>
                                            </p>

                                            <p class="my-6 text-sm text-clay-800">
                                                Hello <em>{{ talentDisplayName }}</em>,<br />
                                                I found your profile on StageAgent.com and would like to talk with you
                                                about a potential performing or networking opportunity. You can view
                                                my StageAgent profile <a :href="`/talent/${memberProfileUrl}`"
                                                    class="underline" target="_blank">here</a>.
                                                If you are interested in talking with me,
                                                please contact me at the email address below:
                                            </p>
                                            <p class="text-sm text-clay-800">
                                                Best,<br />
                                                {{ memberDisplayName }}<br />
                                                {{ memberEmail }}
                                            </p>
                                        </div>

                                        <div v-else class="mt-2">
                                            <p>Your message was successfully sent.</p>
                                        </div>

                                        <div v-if="!isMessageSent"
                                            class="mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
                                            <button :disabled="processing"
                                                class="inline-flex justify-center w-full px-4 py-2 text-base font-medium text-white border border-transparent rounded-md shadow-sm bg-electric-600 hover:bg-electric-700 focus:outline-hidden focus:ring-2 focus:ring-offset-2 focus:ring-electric-500 sm:col-start-2 sm:text-sm"
                                                type="button" @click="submit">
                                                <span v-if="processing">Sending...</span>
                                                <span v-else>Send</span>
                                            </button>
                                            <button ref="cancelButtonRef" :disabled="processing"
                                                class="inline-flex justify-center w-full px-4 py-2 mt-3 text-base font-medium text-gray-700 bg-white border border-clay-500 rounded-md shadow-sm hover:bg-gray-50 focus:outline-hidden focus:ring-2 focus:ring-offset-2 focus:ring-electric-500 sm:mt-0 sm:col-start-1 sm:text-sm"
                                                type="button" @click="closeConfirmation">Cancel
                                            </button>
                                        </div>

                                    </div>

                                    <div v-else class="mt-3 text-center sm:mt-5">
                                        <DialogTitle as="h3" class="mb-6 text-lg font-medium leading-6 text-gray-900">
                                            {{ talentDisplayName }} has disabled messaging!
                                        </DialogTitle>
                                    </div>
                                </div>

                                <div v-else class="mt-3 text-center sm:mt-5">
                                    <DialogTitle as="h3" class="mb-6 text-lg font-medium leading-6 text-gray-900">
                                        <span>Please <a href="/account-settings/membership/upgrade"
                                                class="text-clay-500 underline">upgrade</a> to a pro account to send an
                                            email message!</span>
                                    </DialogTitle>
                                </div>

                            </div>

                        </DialogPanel>
                    </TransitionChild>
                </div>
            </div>
        </Dialog>
    </TransitionRoot>
</template>


<script lang="ts" setup>
// @ts-ignore
import {defineProps, ref} from 'vue';
import {Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot} from '@headlessui/vue';
import {ChatBubbleBottomCenterIcon} from '@heroicons/vue/24/outline';
import {client} from "@/shared";
import {MessageMeRequest} from "@/dtos";

const props = defineProps({
    talentDisplayName: String,
    talentProfileUrl: String,
    memberProfileUrl: String,
    memberDisplayName: String,
    memberEmail: String,
    isMessagingEnabled:Boolean,
    memberIsPro:Boolean
});


const isOpen = ref(false)
const openConfirmation = async () => {
    isOpen.value = true;
}

const closeConfirmation = async () => {
    isOpen.value = false;
}

let processing = ref(false);
let isMessageSent = ref(false);
const submit = async () => {
    processing.value = true;
    await client.post(new MessageMeRequest({profileUrl: props.talentProfileUrl}))
        .then(_ => {
            processing.value = false;
            isMessageSent.value = true;
        });
}
</script>
